// extracted by mini-css-extract-plugin
module.exports = {"switch":"Switch_switch__lwkDM"};